// Get translations for forms labels
import { languages } from '@/locales';

export const getFormLabel = (fieldKey, textKey) => {
  return languages.fr.shared.forms[fieldKey][textKey];
};
